module.exports = __webpack_public_path__ + "static/media/lillie-icon.e4ea5348.png";